import { render, staticRenderFns } from "./marginManage.vue?vue&type=template&id=0dd187b5&scoped=true&"
import script from "./marginManage.vue?vue&type=script&lang=js&"
export * from "./marginManage.vue?vue&type=script&lang=js&"
import style0 from "./marginManage.vue?vue&type=style&index=0&id=0dd187b5&prod&lang=less&scoped=true&"
import style1 from "./marginManage.vue?vue&type=style&index=1&id=0dd187b5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd187b5",
  null
  
)

export default component.exports